let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e48Xd")).then(() => parcelRequire('21r7i'));